import React from 'react';
import PropTypes from 'prop-types';

function EmailContactsButton(props) {
  const {
    buttonText,
    buttonClass,
    buttonIcon,
    clickEvent,
  } = props;

  return (
    <button
      type="button"
      className={buttonClass}
      onClick={clickEvent}
    >
      {buttonIcon && <i className={buttonIcon} />}
      {buttonIcon && buttonText && ' '}
      {buttonText}
    </button>
  );
}

EmailContactsButton.propTypes = {
  buttonText: PropTypes.string,
  buttonClass: PropTypes.string,
  buttonIcon: PropTypes.string,
  clickEvent: PropTypes.func.isRequired,
};

EmailContactsButton.defaultProps = {
  buttonText: undefined,
  buttonClass: undefined,
  buttonIcon: undefined,
};

export default EmailContactsButton;
